class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const button = this.querySelector("[data-quickadd-action]");
    if (!button || button.disabled) return;

    button.addEventListener("click", this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();

    const button = this.querySelector("[data-quickadd-action]");
    const variantId = this.dataset.variantId;
    if (!button || button.disabled || !variantId) return;

    const cart = document.querySelector("cart-drawer");

    button.classList.add("loading");
    button.setAttribute("aria-disabled", "true");
    button.querySelector(".quick-add-label")?.classList.add("hidden");
    button.querySelector(".quick-add-loader")?.classList.remove("hidden");

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id),
      );
      formData.append("sections_url", window.location.pathname);
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "quick-add",
            productVariantId: variantId,
            errors: response.description,
            message: response.message,
          });
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "quick-add",
          productVariantId: variantId,
        });

        if (
          document.querySelector("#product-quic-kview") &&
          document
            .querySelector("#product-quic-kview")
            .classList.contains("active")
        ) {
          document
            .querySelector("#product-quic-kview")
            .classList.remove("active");
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        cart.renderContents(response);
        cart.classList.add("active");
        document.querySelector("body").classList.add("no-scroll");

        cart
          .querySelectorAll("[data-sideDrawer-close]")
          .forEach((closeButton) =>
            closeButton.addEventListener("click", (e) => {
              e.preventDefault();
              cart.classList.remove("active");
              document.querySelector("body").classList.remove("no-scroll");
            }),
          );

        if (cart.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        button.classList.remove("loading");
        button.removeAttribute("aria-disabled");
        button.querySelector(".quick-add-label")?.classList.remove("hidden");
        button.querySelector(".quick-add-loader")?.classList.add("hidden");
      });
  }
}

customElements.define("quick-add", QuickAdd);
